var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "生成对账单",
        visible: _vm.visible,
        width: "1180px",
        top: "5vh",
        "close-on-click-modal": false,
        "custom-class": "generate-statement-dialog",
        "destroy-on-close": "",
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
      },
    },
    [
      _c(
        "el-form",
        {
          ref: "formRef",
          attrs: {
            model: _vm.form,
            rules: _vm.rules,
            "label-width": "130px",
            size: "small",
          },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "商家类型：", prop: "merchantType" } },
            [
              _c(
                "el-select",
                {
                  staticStyle: { width: "100%" },
                  attrs: { placeholder: "请选择商家类型", clearable: "" },
                  on: { change: _vm.onMerchantTypeChange },
                  model: {
                    value: _vm.form.merchantType,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "merchantType", $$v)
                    },
                    expression: "form.merchantType",
                  },
                },
                [
                  _c("el-option", { attrs: { label: "家政供应商", value: 3 } }),
                  _vm._v(" "),
                  _c("el-option", { attrs: { label: "卡券供应商", value: 1 } }),
                  _vm._v(" "),
                  _c("el-option", { attrs: { label: "实物供应商", value: 2 } }),
                  _vm._v(" "),
                  _c("el-option", { attrs: { label: "核销供应商", value: 4 } }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "商家名称：", prop: "merchantId" } },
            [
              _c(
                "el-select",
                {
                  staticStyle: { width: "100%" },
                  attrs: {
                    placeholder: "请先选择商家类型",
                    filterable: "",
                    clearable: "",
                    disabled: !_vm.form.merchantType,
                    loading: _vm.merchantOptionsLoading,
                    "filter-method": _vm.handleMerchantSearch,
                  },
                  on: {
                    focus: function ($event) {
                      return _vm.loadMerchantOptions("")
                    },
                    change: _vm.onMerchantChange,
                  },
                  model: {
                    value: _vm.form.merchantId,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "merchantId", $$v)
                    },
                    expression: "form.merchantId",
                  },
                },
                _vm._l(_vm.merchantOptions, function (item) {
                  return _c("el-option", {
                    key: item.id,
                    attrs: {
                      label: item.supplierName || item.name,
                      value: item.id,
                    },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "账单周期：", prop: "dateRange" } },
            [
              _c("el-date-picker", {
                staticStyle: { width: "100%" },
                attrs: {
                  type: "datetimerange",
                  "range-separator": "-",
                  "start-placeholder": "开始日期",
                  "end-placeholder": "结束日期",
                  "value-format": "yyyy-MM-dd HH:mm:ss",
                  "default-time": ["00:00:00", "23:59:59"],
                },
                on: { change: _vm.onDateRangeChange },
                model: {
                  value: _vm.form.dateRange,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "dateRange", $$v)
                  },
                  expression: "form.dateRange",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _vm.overlapCount !== null
            ? _c(
                "el-form-item",
                { class: { "overlap-warning": _vm.overlapCount > 0 } },
                [
                  _c("div", { staticClass: "overlap-tip" }, [
                    _vm.overlapCount > 0
                      ? _c("i", { staticClass: "el-icon-warning" })
                      : _c("i", { staticClass: "el-icon-success" }),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v("当前选择的对账周期在其他对账单存在相同订单："),
                      _c("b", [_vm._v(_vm._s(_vm.overlapCount))]),
                      _vm._v(" 单"),
                    ]),
                  ]),
                ]
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _vm.canLoadOrderPreview
        ? _c("div", { staticClass: "order-preview" }, [
            _c(
              "section",
              { staticClass: "preview-section" },
              [
                _c("div", { staticClass: "section-title" }, [
                  _vm._v("已结算售后订单"),
                ]),
                _vm._v(" "),
                _c(
                  "el-table",
                  {
                    directives: [
                      {
                        name: "loading",
                        rawName: "v-loading",
                        value: _vm.settledAfterSaleLoading,
                        expression: "settledAfterSaleLoading",
                      },
                    ],
                    attrs: {
                      data: _vm.settledAfterSaleOrders,
                      border: "",
                      size: "mini",
                      "max-height": "260",
                      "empty-text": "暂无已结算售后订单",
                    },
                  },
                  [
                    _c("el-table-column", {
                      attrs: {
                        prop: "statementNo",
                        label: "对账单号",
                        "min-width": "145",
                        "show-overflow-tooltip": "",
                      },
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "orderNo",
                        label: "订单号",
                        "min-width": "135",
                        "show-overflow-tooltip": "",
                      },
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        label: "已结算售后价差",
                        "min-width": "125",
                        align: "right",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c(
                                  "span",
                                  {
                                    class: _vm.getAmountClass(
                                      scope.row.settledAfterSaleDifference
                                    ),
                                  },
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(
                                          _vm.formatSignedAmount(
                                            scope.row.settledAfterSaleDifference
                                          )
                                        ) +
                                        "\n            "
                                    ),
                                  ]
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        418276113
                      ),
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "historyOrderStatusName",
                        label: "历史状态",
                        "min-width": "95",
                      },
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "currentOrderStatusName",
                        label: "当前状态",
                        "min-width": "95",
                      },
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        label: "是否加入对账",
                        "min-width": "105",
                        align: "center",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c(
                                  "span",
                                  {
                                    class: _vm.isOrderIncluded(
                                      "settledAfterSale",
                                      scope.row.orderId
                                    )
                                      ? "included-text"
                                      : "excluded-text",
                                  },
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(
                                          _vm.isOrderIncluded(
                                            "settledAfterSale",
                                            scope.row.orderId
                                          )
                                            ? "加入"
                                            : "不加入"
                                        ) +
                                        "\n            "
                                    ),
                                  ]
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        505186575
                      ),
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "orderTime",
                        label: "下单时间",
                        "min-width": "160",
                      },
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "merchantName",
                        label: "商家",
                        "min-width": "110",
                        "show-overflow-tooltip": "",
                      },
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        label: "操作",
                        width: "105",
                        fixed: "right",
                        align: "center",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c(
                                  "el-button",
                                  {
                                    directives: [
                                      {
                                        name: "has-permi",
                                        rawName: "v-has-permi",
                                        value: [
                                          "admin:merchant:statement:generate",
                                        ],
                                        expression:
                                          "['admin:merchant:statement:generate']",
                                      },
                                    ],
                                    attrs: { type: "text", size: "mini" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.handleOrderInclusionChange(
                                          "settledAfterSale",
                                          scope.row
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(
                                          _vm.isOrderIncluded(
                                            "settledAfterSale",
                                            scope.row.orderId
                                          )
                                            ? "移除对账单"
                                            : "加入对账单"
                                        ) +
                                        "\n            "
                                    ),
                                  ]
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        768848288
                      ),
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "section",
              { staticClass: "preview-section" },
              [
                _c("div", { staticClass: "section-title" }, [
                  _vm._v("跨月订单"),
                ]),
                _vm._v(" "),
                _c(
                  "el-table",
                  {
                    directives: [
                      {
                        name: "loading",
                        rawName: "v-loading",
                        value: _vm.crossMonthLoading,
                        expression: "crossMonthLoading",
                      },
                    ],
                    attrs: {
                      data: _vm.crossMonthOrderData.list,
                      border: "",
                      size: "mini",
                      "max-height": "260",
                      "empty-text": "暂无跨月订单",
                    },
                  },
                  [
                    _c("el-table-column", {
                      attrs: {
                        prop: "orderNo",
                        label: "订单号",
                        "min-width": "155",
                        "show-overflow-tooltip": "",
                      },
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        label: "订单金额",
                        "min-width": "110",
                        align: "right",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _vm._v(
                                  _vm._s(
                                    _vm.formatAmount(scope.row.orderAmount)
                                  )
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        2578107761
                      ),
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "orderStatusName",
                        label: "订单状态",
                        "min-width": "110",
                      },
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        label: "是否加入对账",
                        "min-width": "120",
                        align: "center",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c(
                                  "span",
                                  {
                                    class: _vm.isOrderIncluded(
                                      "crossMonth",
                                      scope.row.orderId
                                    )
                                      ? "included-text"
                                      : "excluded-text",
                                  },
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(
                                          _vm.isOrderIncluded(
                                            "crossMonth",
                                            scope.row.orderId
                                          )
                                            ? "加入"
                                            : "不加入"
                                        ) +
                                        "\n            "
                                    ),
                                  ]
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        22287055
                      ),
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "orderTime",
                        label: "下单时间",
                        "min-width": "170",
                      },
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "merchantName",
                        label: "商家",
                        "min-width": "130",
                        "show-overflow-tooltip": "",
                      },
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        label: "操作",
                        width: "120",
                        fixed: "right",
                        align: "center",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c(
                                  "el-button",
                                  {
                                    directives: [
                                      {
                                        name: "has-permi",
                                        rawName: "v-has-permi",
                                        value: [
                                          "admin:merchant:statement:generate",
                                        ],
                                        expression:
                                          "['admin:merchant:statement:generate']",
                                      },
                                    ],
                                    attrs: { type: "text", size: "mini" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.handleOrderInclusionChange(
                                          "crossMonth",
                                          scope.row
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(
                                          _vm.isOrderIncluded(
                                            "crossMonth",
                                            scope.row.orderId
                                          )
                                            ? "移除对账单"
                                            : "加入对账单"
                                        ) +
                                        "\n            "
                                    ),
                                  ]
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        1359780256
                      ),
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.crossMonthOrderData.total > 0
                  ? _c("el-pagination", {
                      staticClass: "pagination-wrap",
                      attrs: {
                        "current-page": _vm.crossMonthPage.page,
                        "page-sizes": [5, 10, 20],
                        "page-size": _vm.crossMonthPage.limit,
                        layout: "total, sizes, prev, pager, next",
                        total: _vm.crossMonthOrderData.total,
                      },
                      on: {
                        "size-change": _vm.handleCrossMonthSizeChange,
                        "current-change": _vm.handleCrossMonthPageChange,
                      },
                    })
                  : _vm._e(),
              ],
              1
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "el-button",
            {
              on: {
                click: function ($event) {
                  _vm.visible = false
                },
              },
            },
            [_vm._v("取消")]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              attrs: { type: "primary", loading: _vm.submitLoading },
              on: { click: _vm.handleSubmit },
            },
            [_vm._v("确定生成")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }